module.exports = __webpack_public_path__ + "static/media/Home Page_website-11.e9b7513d.png";